import React from 'react';

import { S } from './SpinnerOverlay.style';

export const SpinnerOverlay: React.FC = () => (
  <S.Overlay>
    <S.Container />
  </S.Overlay>
);
